import Container from 'react-bootstrap/Container';
import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import UpdateInsuranceDetailsForm from '../../components/forms/InsuranceDetails/UpdateInsuranceDetailsForm';
import { fetchPublicHealthInsurers } from '../../lib/redux/actions/publicHealthInsurers';
import { useHistory, useParams } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import { problemDataSingleGetByUniqueRef } from '../../lib/redux/actions/problemData';

function UpdateInsuranceDetailsContainer({
  fetchPublicHealthInsurers,
  problemData,
  problemDataSingleGetByUniqueRef,
  isFetchingProblemData,
  isFetchingPublicHealthInsurers,
}) {
  const { uniqueRef, problemDataId } = useParams();
  let history = useHistory();
  const [loadingStarted, setLoadingStarted] = useState(false);
  const [hasConfirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (window && window.tidioChatApi) {
      window.tidioChatApi.hide();
    }
  }, []);

  useEffect(() => {
    fetchPublicHealthInsurers();
    problemDataSingleGetByUniqueRef(problemDataId, uniqueRef);
    if (window && window.tidioChatApi) {
      window.tidioChatApi.hide();
    }
  }, [fetchPublicHealthInsurers, problemDataSingleGetByUniqueRef, uniqueRef, problemDataId]);

  useEffect(() => {
    if (!loadingStarted && isFetchingProblemData) {
      setLoadingStarted(true);
    }
    if (loadingStarted && !isFetchingProblemData && problemData === null) {
      history.push(ROUTES.NOT_FOUND);
    }
  }, [isFetchingProblemData, loadingStarted, problemData, history]);

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          {isFetchingPublicHealthInsurers || isFetchingProblemData ? <p>Loading ...</p> : null}
          {!isFetchingProblemData && !isFetchingPublicHealthInsurers && !hasConfirmed ? (
            <div className="patient-invoice card text-center">
              <div className="card-header">
                <h2>PLEASE READ BEFORE PROCEEDING</h2>
              </div>
              <div className="card-body">
                <h3>Updating your Insurance Details</h3>
                <br />
                <p>Please ensure all details given match what your insurer holds.</p>
                <br />
                <div>
                  <button type="button" onClick={() => setConfirmed(true)} className="btn-primary text-capitalize btn btn-primary">
                    I understand and still need to update my details
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {!isFetchingProblemData && !isFetchingPublicHealthInsurers && hasConfirmed ? <UpdateInsuranceDetailsForm /> : null}
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  ...state.invoices,
  ...state.publicHealthInsurers,
});

const mapDispatchToProps = {
  fetchPublicHealthInsurers,
  problemDataSingleGetByUniqueRef,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateInsuranceDetailsContainer);
